import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const WrapperBody = styled.div`
  width: 100%;
  padding: 20px;
  
`;

export const WrapperContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  
`;

export const WrapperBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
`;

export const WrapperInput = styled.div`
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;

export const InputRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
`;

export const TabsContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
`;

export const TabPanel = styled.div`
  width: 100%;
`;

export const AutocompleteWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AutocompleteDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
`;

export const AutocompleteItem = styled.div`
  padding: 12px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

